import {StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {shadowStyles, bodyFontSize} =
  getLayoutDescriber();

const HORIZONTAL_PADDING = Styles.Spacing.m3 + Styles.Spacing.m2 * 2;
const BUTTON_GAP = Styles.Spacing.m3;
const BUTTON_WIDTH = (Styles.ScreenWidth - HORIZONTAL_PADDING - BUTTON_GAP) / 2;

export const checkoutStylesTemplate1 = StyleSheet.create({
  payYourBalanceMargin: {
    marginBottom: Styles.Spacing.m0,
  },
  preparationContainerMargin: {
    marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  preparationLabel: {
    fontSize: bodyFontSize(),
  },
  checkoutItemsMargin: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginTop: Styles.Spacing.m0,
  },
  prepMethodBtnStyles: {
    minHeight: Styles.Heights.touchTargetHeight1 - 2,
    paddingHorizontal: Styles.Spacing.m4,
    borderWidth: 2,
  },
  itemLabelMargin: {marginTop: Styles.Spacing.m1},
  rowContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  cartDescriptionSubView: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: Styles.Spacing.m1,
    marginLeft: Styles.Spacing.m2,
  },
  cartPriceMain: {
    flex: 0.4,
    justifyContent: 'center',
    top: -2,
    alignItems: 'flex-end',
    rowGap: Styles.Spacing.m1 + 1,
  },
  promoDescriptionMain: {
    flex: 0.8,
    justifyContent: 'center',
    left: Styles.Spacing.m2,
    top: -2,
    alignItems: 'flex-start',
    rowGap: Styles.Spacing.m1 + 1,
  },
  bundlePromoLabelMargin: {
    marginLeft: Styles.Spacing.m1 + 1,
  },
  promoTrashIcon: {
    flex: 0.15,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    marginRight: Styles.Spacing.m2,
  },
  bundlePromoView: {
    marginTop: Styles.Spacing.m0,
  },
  subtotalSection: {
    marginTop: Styles.Spacing.m0,
  },
  searchProductContainer: {
    backgroundColor: Styles.white,
    marginTop: Styles.Spacing.m2,
    marginHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    paddingVertical: Styles.Spacing.m2,
    flexDirection: 'row',
    alignItems: 'center',
    ...shadowStyles().lightShadow,
  },
  receiptContent: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m3,
    paddingTop: Styles.Spacing.m3,
  },
  floatButton: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: Styles.Spacing.m3,
    right: Styles.Spacing.m3,
  },
  doneBtnView: {
    paddingVertical: Styles.Spacing.m3 - Styles.Spacing.m1,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  emailView: {
    paddingVertical: Styles.Spacing.m3 - Styles.Spacing.m1,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    backgroundColor: Styles.white,
  },
});

export const checkoutStylesTemplate2 = StyleSheet.create({
  payYourBalanceMargin: {
    marginBottom: Styles.Spacing.m2,
  },
  preparationContainerMargin: {
    marginTop: Styles.Spacing.m3,
  },
  preparationLabel: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
  },
  checkoutItemsMargin: {
    marginTop: Styles.Spacing.m4 - 2,
    paddingHorizontal: Styles.Spacing.m2 + Styles.Spacing.m3,
  },
  prepMethodBtnStyles: {
    minHeight: Styles.Spacing.m4,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m1,
    borderWidth: 1,
  },
  itemLabelMargin: {marginTop: Styles.Spacing.m0},
  rowContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    marginLeft: Styles.Spacing.m2,
    marginTop: Styles.Spacing.m1,
  },
  cartDescriptionSubView: {
    flex: 1,
    flexDirection: 'row',
    marginLeft: Styles.Spacing.m3,
    marginTop: Styles.Spacing.m1,
  },
  cartPriceMain: {
    flex: 0.4,
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: Styles.Spacing.m1 - 3,
  },
  promoDescriptionMain: {
    flex: 0.8,
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: Styles.Spacing.m1,
  },
  bundlePromoLabelMargin: {
    marginLeft: Styles.Spacing.m0,
  },
  promoTrashIcon: {
    flex: 0.15,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
  },
  bundlePromoView: {
    marginTop: Styles.Spacing.m1,
    marginBottom: Styles.Spacing.m2,
  },
  subtotalSection: {
    marginTop: Styles.Spacing.m2,
  },
  searchProductContainer: {
    marginTop: Styles.Spacing.m2,
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m1,
    paddingVertical: Styles.Spacing.m2,
    flexDirection: 'row',
    alignItems: 'center',
  },
  receiptContent: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m3,
    paddingTop: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  floatButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  doneBtnView: {
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    width: BUTTON_WIDTH,
  },
  emailView: {
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    width: BUTTON_WIDTH,
    borderWidth: 2,
    backgroundColor: Styles.Colors.PayNew.white01,
  },
});
